<div class="flex flex-col w-full">
	<ui-section title="Mortgage Funder">
		<div section-content class="gap-6">
			<ui-info-row
				infoLabel="Name"
				matTooltip="This is the mortgage funder name from your instructions"
				matTooltipPosition="right"
				class="p-2"
			>
				<app-input
					[ngModel]="_mortgage.lenderContactName"
					(debounce)="setLenderContactName($event)"
				></app-input>
			</ui-info-row>
			<ui-info-row
				infoLabel="Phone #"
				matTooltip="This is the mortgage funder phone from your instructions"
				matTooltipPosition="right"
				class="p-2"
			>
				<app-input
					[ngModel]="_mortgage.lenderContactPhoneNumber"
					(debounce)="setLenderContactPhoneNumber($event)"
				></app-input>
			</ui-info-row>
			<ui-info-row
				infoLabel="Email"
				matTooltip="This is the mortgage funder email address from your instructions"
				matTooltipPosition="right"
				class="p-2"
			>
				<app-input
					[ngModel]="_mortgage.lenderContactEmail"
					(debounce)="setLenderContactEmail($event)"
				></app-input>
			</ui-info-row>
		</div>
	</ui-section>
</div>
